module.exports = __webpack_public_path__ + "static/img/product_title_icon.12ebb9e5.svg";